export default "__VITE_ASSET__ByTNVa6L__ 640w, __VITE_ASSET__ClmpK33j__ 1024w";